/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const FilterSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
<svg class="${
    props.svgStyles ?? ''
  }" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="100%" height="100%" viewBox="0 0 22 22">
  <defs>
    <clipPath id="clip-path">
      <rect id="Rectangle_454" data-name="Rectangle 454" width="100%" height="100%" fill="currentColor"/>
    </clipPath>
  </defs>
  <g id="Group_3198" data-name="Group 3198" transform="translate(-276 -114)">
    <g id="Group_3117" data-name="Group 3117" transform="translate(276 114)">
      <g id="Group_2460" data-name="Group 2460" clip-path="url(#clip-path)">
        <path id="Path_1631" data-name="Path 1631" d="M19.106,22a.579.579,0,0,1-.578-.578V14.474a.578.578,0,1,1,1.157,0v6.948a.579.579,0,0,1-.578.578M11,22a.579.579,0,0,1-.578-.578V18.553a.116.116,0,0,0-.089-.113,2.894,2.894,0,1,1,1.335,0,.116.116,0,0,0-.089.113v2.868A.579.579,0,0,1,11,22m0-8.106a1.738,1.738,0,1,0,1.738,1.738A1.739,1.739,0,0,0,11,13.894M2.894,22a.579.579,0,0,1-.578-.578V11a.578.578,0,1,1,1.157,0V21.422A.579.579,0,0,1,2.894,22m16.211-9.264a2.89,2.89,0,0,1-.668-5.7.116.116,0,0,0,.089-.112V.578a.578.578,0,1,1,1.157,0V6.921a.116.116,0,0,0,.089.112,2.89,2.89,0,0,1-.668,5.7m0-4.632a1.738,1.738,0,1,0,1.738,1.738A1.739,1.739,0,0,0,19.106,8.1M11,11.578A.579.579,0,0,1,10.422,11V.578a.578.578,0,1,1,1.157,0V11a.579.579,0,0,1-.578.578M2.894,9.262a2.89,2.89,0,0,1-.668-5.7.116.116,0,0,0,.089-.112V.578a.578.578,0,0,1,1.157,0V3.447a.116.116,0,0,0,.089.112,2.89,2.89,0,0,1-.668,5.7m0-4.632A1.738,1.738,0,1,0,4.632,6.368,1.739,1.739,0,0,0,2.894,4.631" transform="translate(0.001 0)" fill="currentColor"/>
      </g>
    </g>
  </g>
</svg>

  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default FilterSvg
